<script setup>
import { useIsMobile} from "../shared/utilities";
const { isMobile } = useIsMobile();

defineProps({
  displayAmount: {
    type: String,
    default: "",
  },
  isInrCurrency: {
    type: Boolean,
    default: false,
  },
  isLoading: {
    type: Boolean,
    default: false,
  },
  t: {
    type: Function,
    required: true,
  },
  timerValue: {
    type: String,
    default: "00:00",
  },
  timerVisible: {
    type: Boolean,
    default: false,
  },
  timerWarning: {
    type: Boolean,
    default: false,
  },
});
</script>

<template>
  <div class="top-meta-desktop grid-full">
    <div class="panel amount-panel" :style="[isMobile ? 'flex-direction: row' : '']">
      <div class="amount-row">
        <span class="amount-kicker">{{ t("amountLabel") }}</span>
        <span class="amount-display">
          <span v-if="isLoading" class="spinner"></span>
          <template v-else>
            <span>{{ displayAmount }}</span>
          </template>
        </span>
      </div>

      <div
        v-if="timerVisible"
        class="timer-row"
        :class="{ warning: timerWarning }"
      >
        <span class="timer-kicker">{{ t("timeLeft") }}</span>
        <span class="timer-display">{{ timerValue }}</span>
      </div>
    </div>
  </div>
</template>
